
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experts/[slug]",
      function () {
        return require("private-next-pages/experts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experts/[slug]"])
      });
    }
  